import React, { Suspense, lazy, useEffect, useState } from "react";
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";

import Home from './pages/Home';
import Header from './components/Header';
import ThankYou from "./pages/ThankYou";
import ThankYouRejected from "./pages/thankyou-ineligible";
import { pageViewEvent } from './services/adobeDataLayer'



function App() {
  //Trigger AA Page View Event
  useEffect(() => {
    pageViewEvent("landing page");
  }, [])
  return (
    <>
      <Router basename={window.location.pathname}>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/thankyou-not-eligible" element={<ThankYouRejected />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;